import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../../core/shared/shared.module";
import { LoginRest } from "../../login/login.rest";
import { DictionaryRest } from "../../dictionaries/dictionary/dictionary.rest";
import { AbsencesListComponent } from "./absences-list.component";
import { AbsencesListRouting } from "./absences-list.routing";
import { AbsencesRest } from "../absences.rest";
import { AbsencesCalendarModule } from "../absences-calendar/absences-calendar.module";
import { WorklogsRest } from "../../worklogs/worklogs.rest";

@NgModule({
  imports: [
    CommonModule,
    AbsencesListRouting,
    SharedModule,
    AbsencesCalendarModule
  ],
  declarations: [AbsencesListComponent],
  exports: [],
  providers: [AbsencesRest, LoginRest, DictionaryRest, WorklogsRest]
})
export class AbsencesListModule { }